import React, {useState} from 'react';
import {useParams} from "wouter";
import {getHttpClient} from "@/utils/api.ts";
import {AssetResponseItem, GenericAsset, TweetAsset} from "@/@types/AssetTypes.ts";
import Button from "@/components/form/Button.tsx";
import TwitterThreadPreview from "@/components/previews/TwitterThreadPreview.tsx";
import FacebookPostPreview from "@/components/previews/FacebookPostPreview.tsx";

function PostVariations() {
    const params = useParams<{type: string, id: string}>();
    const id = params.id;
    const [originalPost, setOriginalPost] = useState<AssetResponseItem>(null);
    const [variations, setVariations] = useState<AssetResponseItem[]>(null);
    const [loading, setLoading] = useState(false)
    const generate = ()=>{
        setLoading(true)
        getHttpClient().post('/ai/generate_variations', {
            post_id:id
        }).then(({data})=>{
            setLoading(false)
            setOriginalPost(data.post);
            setVariations(data.variations);
        })
    }
    const [index, setIndex] = useState(0);
    const currentVariation = variations ? variations[index] : null;
    return (
        <div>
            <Button loading={loading} className={"btn btn-primary"} onClick={generate}>Generate Variations</Button>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                {
                    originalPost ? <div>
                        <div className={"rounded-xl border  overflow-hidden border-base-200"}>

                            <div className={"text-center py-1 bg-primary text-white"}>
                                <button className={"btn btn-ghost"}>Current</button>

                            </div>
                            <PreviewAsset asset={originalPost} />
                        </div>
                        </div>
                        : null
                }
                <div>
                    <div className={"rounded-xl border  overflow-hidden border-base-200"}>
                        <div className={"grid grid-cols-3 items-center py-1 bg-base-300"}>
                            <button
                                onClick={() => setIndex(index - 1)}
                                className={"btn btn-ghost"}
                                disabled={index <= 0}
                            >Previous
                            </button>
                            <button className={"btn btn-ghost"}>Suggested</button>
                            <button
                                disabled={!variations || index === variations.length - 1}
                                onClick={() => setIndex(index + 1)}
                                className={"btn btn-ghost"}>Next
                            </button>
                        </div>
                        {
                            currentVariation ? <PreviewAsset asset={currentVariation}/> : null
                        }

                    </div>
                    <div className={" mt-2"}>
                        <button className="btn w-full btn-primary">USE THIS</button>
                    </div>
                    {/*{*/}
                    {/*    variations && Array.isArray(variations) ? variations.map((v, index)=>{*/}
                    {/*        return <PreviewAsset asset={v}  key={String(index)}/>*/}
                    {/*    }) : null*/}
                    {/*}*/}
                </div>

            </div>
        </div>
    );
}

function PreviewAsset({asset}: { asset: AssetResponseItem }) {
    if (asset.type === "twitter-post"){
        return <TwitterThreadPreview post={asset.data as TweetAsset}
            post_at={asset.post_at}
         account={asset.account} />
    }else if(asset.type === "facebook-page-post"){
        return <FacebookPostPreview post={(asset.data as GenericAsset).post}
            post_at={asset.post_at}
            account={asset.account}

        />
    }
}

export default PostVariations;
